import { render } from "./QuotesList.vue?vue&type=template&id=1f87d72c"
import script from "./QuotesList.vue?vue&type=script&lang=js"
export * from "./QuotesList.vue?vue&type=script&lang=js"
script.render = render

export default script